import React, { memo } from 'react';
import { format } from 'date-fns';
import * as GStyled from '../../../styles/components';
import * as Styled from './styled';
import { ReportSnapshot } from '../../../models';
import { REPORT_CURRENCIES, DATE_TIME_FORMAT } from '../../../constants';
import ReportSettingPIT from './ReportSettingPIT';
import { Icon } from '../../../components';
import { useFormatDateByLocale } from '../../../util/hooks/useFormatDateByLocale';

interface ReportSettingProps {
  reportSnapshot: ReportSnapshot;
}

function ReportSettingCommitment({
  reportSnapshot,
}: ReportSettingProps): JSX.Element {
  const {
    currency,
    asOfDate1,
    asOfDate2,
    asOfDate1Custom,
    runByCalendarYear,
    runByFiscalYear,
    isBaseRentOnly,
  } = reportSnapshot;
  const formattedAsOfDate = useFormatDateByLocale(asOfDate2);

  return (
    <>
      <Styled.ReportSettingItem hasSecondColumn={true}>
        <Icon name="calendar" />
        <GStyled.Text>Start Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {asOfDate1Custom
            ? `${asOfDate1Custom.month}/${asOfDate1Custom.year}`
            : format(asOfDate1, DATE_TIME_FORMAT.MONTH_YEAR)}
        </GStyled.Text>
        <GStyled.Text>End Date</GStyled.Text>
        <GStyled.Text fontWeight="medium">
        <GStyled.Text fontWeight="medium">{formattedAsOfDate}</GStyled.Text>
        </GStyled.Text>
      </Styled.ReportSettingItem>
      <ReportSettingPIT reportSnapshot={reportSnapshot} />
      <Styled.ReportSettingItem hasSecondColumn={isBaseRentOnly}>
        <Icon name="gear" />
        <GStyled.Text>Run by</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {runByCalendarYear
            ? 'Calendar Year'
            : runByFiscalYear
            ? 'Fiscal Year'
            : 'None'}
        </GStyled.Text>
        {isBaseRentOnly && (
          <>
            <GStyled.Text>Run With</GStyled.Text>
            <GStyled.Text fontWeight="medium">Fixed Payments Only</GStyled.Text>
          </>
        )}
      </Styled.ReportSettingItem>
      <Styled.ReportSettingItem>
        <Icon name="currency" />
        <GStyled.Text>Currency</GStyled.Text>
        <GStyled.Text fontWeight="medium">
          {REPORT_CURRENCIES[currency].label}
        </GStyled.Text>
      </Styled.ReportSettingItem>
    </>
  );
}

export default memo(ReportSettingCommitment);
